import * as React from 'react';
import Icon from 'src/core/ui/icon';

export interface CheckboxProps {
    style?: 'light' | 'dark';
    label?: string | React.ReactNode;
    value?: boolean;
    onChange?: (value: boolean) => void;
}

export interface CheckboxState {
    checked: boolean;
}

export default class Checkbox extends React.Component<CheckboxProps, CheckboxState> {
  constructor(props: CheckboxProps) {
    super(props);

    this.state = {
        checked: false
    }
  }

  handleChange = (e) => {
      this.setState({checked: e.target.checked});

      if(this.props.onChange)
        this.props.onChange(e.target.checked)
  }

  public componentWillReceiveProps(nextProps: CheckboxProps){
    if(nextProps.value != this.props.value){
      this.setState({checked: nextProps.value || false})
    }
  }

  public componentDidMount()
  {
      this.setState({checked: this.props.value || false})
  }

  public render() {
    return (
      <label className={'checkbox ' + (this.props.style || 'light')}>
            {this.props.label}
            <input type='checkbox' checked={this.state.checked} onChange={this.handleChange}/>
            {this.state.checked && <Icon type='check' />}
            <span className='checkmark'></span>
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/checkbox.tsx